import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Sidebar } from "./Sidebar";
import { ProtectedRoutes } from "../../routes/ProtectedRoutes";
import { Background } from "./Background";
import { MainContent } from "./MainContent";
import { LayoutProps } from "./types/LayoutTypes";

/**
 * Main layout component that provides the basic structure of the application.
 * It includes:
 * - CssBaseline for consistent styling
 * - Background with gradient overlay
 * - Sidebar navigation
 * - Main content area with header and protected routes
 */
export const Layout: React.FC<LayoutProps> = () => {
  return (
    <Background>
      <CssBaseline />
      <Sidebar />
      <MainContent>
        <ProtectedRoutes />
      </MainContent>
    </Background>
  );
}; 